import { toast } from "sonner";
import { PlatformAppsAdmin } from "@lumanity/ui/projects";

const RegisteredApps = () => <PlatformAppsAdmin onChanged={(m) => toast.success(m)} onError={(e) => toast.error(e.message)} />;

export default RegisteredApps;
